module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "repo-item",
    attrs: {
      "to": {
        name: 'REPO_DETAIL',
        params: {
          username: _vm.repo.owner.login,
          reponame: _vm.repo.name
        }
      }
    }
  }, [_c('repo-content', {
    attrs: {
      "repo": _vm.repo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f1ba80d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RepoItem.vue
// module id = 465
// module chunks = 2